import { EducatorsTeamsTeamApplicationIndex } from "@/types/serializers"
import { useProps } from "@/lib/page-rendering"

export type IndexProps = {
  team_applications: Array<EducatorsTeamsTeamApplicationIndex>
  team_name: string
}

export const useIndexProps = () => useProps<IndexProps>()
